<template>
  <div>
    <div :class="typeMessage" role="alert" v-if="message != ''">
      {{message}}
    </div> 
    <div class="form-group">
      <h4>Para solicitar la revisión de su asignación por favor describa los cambios incorporados</h4>
      <label for="observation">Observación</label>
      <textarea v-model="observation" class="form-control" id="observation" rows="5"></textarea>
      <br>
      <button @click.prevent="sendApproveAssignment" type="button" class="btn btn-primary">Guardar</button>
    </div>                                    
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Assignments",
  props: ['assignment', 'user'],
  data() {
    return {
      typeMessage: '',
      message: '',
      observation: '',
      quality: null,
      assignmentLocal: this.assignment
    }
  },
  methods: {
    setHeaders () {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      axios.defaults.headers["x-csrf-token"] = token
      axios.defaults.headers.common["Accept"] = "application/json"
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    },
    async sendApproveAssignment() {
      let request = await axios.get(`/update_quality_assignment?assignment_id=${this.assignmentLocal.id}&quality=nil&user_id=${this.user.id}&observation=${this.observation}&response=1`, {}, {})
      if (request.status == 200) {
        this.assignmentLocal = request.data.assignment
        this.showMessage(request.data.message, 'alert-success', 3000)
      } else {
        this.showMessage('Error', 'alert-danger', 3000)
      }
    },
    showMessage(message, typeMessage, time){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', time)
    }
  }
}
</script>

<style scoped>

</style>

